import CreatePepDialog from "@/components/companies/pep/CreatePepDialog.vue";
import EditPepDialog from "@/components/companies/pep/EditPepDialog.vue";
import DeletePepDialog from "@/components/companies/pep/DeletePepDialog.vue";
import SearchInput from "@/components/global/SearchInput.vue";

export default {
  name: "Peps",
  data: () => ({
    headers: [
      {
        text: "PEP",
        value: "code",
        align: "center",
        sortable: false,
        class: "primary--text",
      },
      {
        text: "Descripción",
        value: "pep_description",
        align: "center",
        sortable: false,
        class: "primary--text",
      },
      {
        text: "Responsable",
        value: "responsible_id.fullName",
        align: "center",
        sortable: false,
        class: "primary--text",
      },
      {
        text: "Estado",
        value: "active",
        align: "center",
        sortable: false,
        class: "primary--text",
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        sortable: false,
        class: "primary--text",
      },
    ],
    search: "",
    editedItem: {},
    deletedItem: {},
    currentPage: 1,
    limit: 5,
    rowsPerPage: [{ value: 5 }, { value: 10 }, { value: 15 }, { value: 20 }, { value: 25 }, { value: 30 }]
  }),

  computed: {
    peps() {
      return this.$store.getters["peps/getPeps"];
    },
    paginationPages() {
      return this.$store.getters["peps/getPaginationPages"];
    },
    isLoading() {
      return this.$store.state.peps.isLoading;
    },
  },

  watch: {},

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("peps/getPeps", { page: 1,limit: this.limit });
      this.$store.dispatch("peps/updateCurrentPage", 1);
    },

    editItem(item) {
      this.editedItem = { ...item };
    },

    deleteItem(item) {
      this.deletedItem = { ...item };
    },

    listenPagination() {
      this.$store.dispatch("peps/getPeps", {
        page: this.currentPage,
        search: this.search,
        limit : this.limit
      });
      this.$store.dispatch("peps/updateCurrentPage", this.currentPage);
    },

    resetFilter() {
      this.search = "";
      this.currentPage = 1;
      this.limit = 5
    },
  },
  components: {
    CreatePepDialog,
    EditPepDialog,
    DeletePepDialog,
    SearchInput,
  },
};
